// Mock data for the editable template system
export const mockRootProps = {
  businessInfo: {
    name: "Visibeen Medical Center",
    tagline: "Your trusted healthcare partner",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas faucibus, nunc consequat cursus cursus, urna diam euismod arcu, et iaculis turpis sapien quis velit. Nam maximus lectus eu consequat pulvinar. Duis porttitor euismod.",
    logo: null,
    heroTitle: "Pankaj Thakur",
    heroSubtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incid",
    ctaText: "BOOK Now"
  },
  services: [
    {
      id: 1,
      name: "Lorem ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
      image: "/images/medical-service-1.jpg"
    },
    {
      id: 2,
      name: "Lorem ipsum", 
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
      image: "/images/medical-service-2.jpg"
    },
    {
      id: 3,
      name: "Lorem ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua", 
      image: "/images/medical-service-3.jpg"
    },
    {
      id: 4,
      name: "Lorem ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
      image: "/images/medical-service-4.jpg"
    },
    {
      id: 5,
      name: "Lorem ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
      image: "/images/medical-service-5.jpg"
    },
    {
      id: 6,
      name: "Lorem ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
      image: "/images/medical-service-6.jpg"
    },
    {
      id: 7,
      name: "Lorem ipsum", 
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
      image: "/images/medical-service-7.jpg"
    },
    {
      id: 8,
      name: "Lorem ipsum",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
      image: "/images/medical-service-8.jpg"
    }
  ],
  aboutUs: {
    title: "About Us",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas faucibus, nunc consequat cursus cursus, urna diam euismod arcu, et iaculis turpis sapien quis velit. Nam maximus lectus eu consequat pulvinar. Duis porttitor euismod.",
    additionalText: "Donec nulla est, rutrum in dui eget, ultricies mollis leo. Duis non diam sodales, tristique enim vitae, lacinia mauris.",
    ctaText: "Read more",
    image: "/images/medical-team.jpg"
  },
  latestUpdates: [
    {
      id: 1,
      title: "2369 Robinson Lane Jackson,OH 45640",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim",
      image: "/images/medical-update-4.jpg",
      date: null
    },
    {
      id: 2,
      title: "2369 Robinson Lane Jackson,OH 45640", 
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim",
      image: "/images/medical-update-1.jpg",
      date: null
    },
    {
      id: 3,
      title: "2369 Robinson Lane Jackson,OH 45640",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim",
      image: "/images/medical-update-2.jpg", 
      date: "Posted on - 26 june 2025"
    },
    {
      id: 4,
      title: "2369 Robinson Lane Jackson,OH 45640",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim",
      image: "/images/medical-update-3.jpg",
      date: "Posted on - 26 june 2025"
    }
  ],
  testimonials: [
    {
      id: 1,
      name: "Syed Ekram",
      review: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      image: "/images/testimonial-avatar.jpg",
      rating: 5
    },
    {
      id: 2,
      name: "Syed Ekram", 
      review: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      image: "/images/testimonial-avatar.jpg",
      rating: 5
    }
  ],
  faq: [
    {
      id: 1,
      question: "What plumbing services do you offer?",
      answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim",
      isExpanded: false
    },
    {
      id: 2,
      question: "What plumbing services do you offer?",
      answer: null,
      isExpanded: false
    },
    {
      id: 3,
      question: "What plumbing services do you offer?",
      answer: null,
      isExpanded: false
    },
    {
      id: 4,
      question: "What plumbing services do you offer?",
      answer: null,
      isExpanded: false
    },
    {
      id: 5,
      question: "What plumbing services do you offer?",
      answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim",
      isExpanded: true
    },
    {
      id: 6,
      question: "What plumbing services do you offer?",
      answer: null,
      isExpanded: false
    }
  ],
  contactInfo: {
    address: "8819 Ohio St. South Gate, CA 90280",
    email: "Ourstudio@hello.com", 
    phone: "+1 386-688-3295",
    workingHours: "Monday- Saturday : 10:00am to 07:00pm.",
    sundayHours: "SUNDAY : CLOSED"
  },
  socialMedia: {
    instagram: "#",
    facebook: "#",
    twitter: "#"
  },
  footerLinks: {
    services: ["Lorem ipsum", "Lorem ipsum", "Lorem ipsum", "Lorem ipsum"],
    company: ["Service", "About Us", "Client Testimonial", "Blog", "Latest updates", "Contact Us"]
  },
  newsletter: {
    title: "Join a Newsletter",
    placeholder: "Enter Your Email",
    buttonText: "Send"
  },
  location: {
    title: "Find Us",
    subtitle: "Visit our location or reach out to us for more information",
    address: "8819 Ohio St. South Gate, CA 90280"
  }
  
};